'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _commonFunc = require('appkit-react-utils/commonFunc');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Animations = function (_Component) {
  _inherits(Animations, _Component);

  function Animations() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Animations);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Animations.__proto__ || Object.getPrototypeOf(Animations)).call.apply(_ref, [this].concat(args))), _this), _this.renderContent = function () {
      var _this$props = _this.props,
          style = _this$props.style,
          className = _this$props.className,
          active = _this$props.active,
          children = _this$props.children,
          _this$props$effect = _this$props.effect,
          effect = _this$props$effect === undefined ? '' : _this$props$effect;

      var content = void 0;
      content = _react2.default.Children.map(children, function (child) {
        return _react2.default.cloneElement(child, {
          className: (0, _classnames2.default)(child.props && child.props.className, className, _defineProperty({}, 'animated ' + effect, !!effect && active)),
          style: style
        });
      });
      return content;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Animations, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var element = _reactDom2.default.findDOMNode(this);
      if (element) {
        element.addEventListener((0, _commonFunc.getAnimationEvent)(), function () {
          _this2.props.afterAnimation && _this2.props.afterAnimation();
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var element = _reactDom2.default.findDOMNode(this);
      if (element) {
        element.removeEventListener((0, _commonFunc.getAnimationEvent)(), function () {});
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.renderContent() || null;
    }
  }]);

  return Animations;
}(_react.Component);

Animations.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  effect: _propTypes2.default.string,
  active: _propTypes2.default.bool,
  afterAnimation: _propTypes2.default.func
};

Animations.displayName = 'Animations';

exports.default = Animations;